<div class="config-section">
  <h3 class="config-category">{{ category }}</h3>
  <mat-selection-list class="config-list" [(ngModel)]="selectedOptions" (ngModelChange)="onSelectionChange($event)">
    <mat-list-option *ngFor="let item of items" [value]="item.config.name" class="config-item">
      {{ item.meta.label || item.config.description }}
    </mat-list-option>
  </mat-selection-list>
</div>
